// contacts/endpoints.js
import { factory } from "vivialconnect-js-core";

//NOTE: do not use spread syntax here.
//helper == {init, BASE_URL}
const helper = factory.initEndpoints();

export default {
  init: helper.init,
  logs: (id) => `${helper.BASE_URL}/accounts/${id}/logs.json`,
  logsAggregate: (id) =>
    `${helper.BASE_URL}/accounts/${id}/logs/aggregate.json`,
};
